module.exports = __webpack_public_path__ + "static/vita_winfried_neun-96fbd8ec51666fd6d86015730b94a7b3.pdf";